import { styled } from "styled-components"

import { colors, Popover, spacing } from "@minuthq/meatball-ui-react"

import { TPartialLocation } from "src/router/routeTypes"
import { InternalLink } from "src/ui/Link/InternalLink"
import { MCard } from "src/ui/MCard/MCard"

export function ParadiseEcommerceNavPopover({
  trigger,
  navlinks,
}: {
  trigger: React.ReactNode
  navlinks: {
    to: TPartialLocation
    children: string
  }[]
}) {
  return (
    <Popover
      trigger={trigger}
      triggerType="hover"
      placement="right-start"
      offset={({ rects }) => {
        return {
          mainAxis: -15,
          // Push the floating element up by 1/4 of its height
          alignmentAxis: (rects.floating.height / 4) * -1,
        }
      }}
    >
      <MCard padding={0}>
        {navlinks.map((navlink) => (
          <StyledLink key={navlink.to.pathname} to={navlink.to}>
            {navlink.children}
          </StyledLink>
        ))}
      </MCard>
    </Popover>
  )
}

const StyledLink = styled(InternalLink)`
  display: flex;
  gap: ${spacing.S};
  align-items: center;
  padding: ${spacing.S};
  text-decoration: none;

  &:hover {
    background-color: ${colors.neutral};
    text-decoration: none;
  }
`
